/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Breakpoints } from '@01_people/ui-library';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import Header from '../header';
import ContentWrapperSC from './content-wrapper.styled';
import * as ActionCreators from '../../../redux/action';
import AppLoader from '../../app-loader';
import { getOrientation, isMobileDevice } from '../../../utils/device';
import DocumentIcon from '../document/document-icon';
import ErrorPage from '../../error-page';
import routerConfig from '../routes';
import RouteWithSubRoutes from '../route-with-sub-routes';

class ContentWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { setBrowserType } = this.props;
    setBrowserType({ isMobile: isMobileDevice() });

    this.updateWindowDimensions();

    window.addEventListener('resize', this.updateWindowDimensions);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.modules !== state.modules) {
      return {
        modules: props.modules,
        routes: props.modules
          ? routerConfig.filter(route =>
              props.modules.find(module => module === route.module)
            )
          : []
      };
    }
    return null;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const {
      responsiveHeaderView,
      responsiveContentView,
      setResponsiveHeaderView,
      setResponsiveContentView,
      setDeviceOrientation
    } = this.props;

    const floatMaxSmall = parseFloat(Breakpoints.maxSmall.slice(0, -2));
    const floatMaxMedium = parseFloat(Breakpoints.maxMedium.slice(0, -2));
    const isResponsiveHeaderWidth = window.innerWidth <= floatMaxMedium;
    const isResponsiveContentWidth = window.innerWidth <= floatMaxSmall;

    if (responsiveHeaderView !== isResponsiveHeaderWidth) {
      setResponsiveHeaderView(isResponsiveHeaderWidth);
    }

    if (responsiveContentView !== isResponsiveContentWidth) {
      setResponsiveContentView(isResponsiveContentWidth);
    }

    setDeviceOrientation({ orientation: getOrientation() });
  };

  render() {
    const {
      initialLoading,
      responsiveHeaderView,
      responsiveContentView,
      backToAppUrl,
      appType
    } = this.props;
    const { routes } = this.state;

    if (initialLoading) {
      return <AppLoader />;
    }

    return (
      <>
        <DocumentIcon />
        <Header
          responsiveContentView={responsiveContentView}
          responsiveHeaderView={responsiveHeaderView}
          backToAppUrl={backToAppUrl}
          appType={appType}
        />
        <ContentWrapperSC>
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <Redirect to={routes.length > 0 ? routes[0].path : '/404'} />
              )}
            />
            {routes.map((route, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <RouteWithSubRoutes key={`${route.path}-${i}`} {...route} />
            ))}
            <Route
              path="/404"
              exact
              render={routerProps => (
                <ErrorPage {...routerProps} status={404} />
              )}
            />
            <Redirect to="/404" />
          </Switch>
        </ContentWrapperSC>
      </>
    );
  }
}

ContentWrapper.propTypes = {
  setResponsiveHeaderView: PropTypes.func.isRequired,
  setResponsiveContentView: PropTypes.func.isRequired,
  responsiveHeaderView: PropTypes.bool.isRequired,
  responsiveContentView: PropTypes.bool.isRequired,
  initialLoading: PropTypes.bool.isRequired,
  setDeviceOrientation: PropTypes.func.isRequired,
  setBrowserType: PropTypes.func.isRequired,
  backToAppUrl: PropTypes.string.isRequired,
  appType: PropTypes.string.isRequired,
  modules: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapStateToProps = state => {
  return {
    initialLoading: state.ui.initialLoading,
    responsiveHeaderView: state.ui.responsiveHeader,
    responsiveContentView: state.ui.responsiveContent,
    backToAppUrl: state.backToAppUrl,
    appType: state.ui.appType,
    modules: state.ui.modules
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setResponsiveHeaderView: ActionCreators.setResponsiveHeaderView,
      setResponsiveContentView: ActionCreators.setResponsiveContentView,
      setDeviceOrientation: ActionCreators.setDeviceOrientation,
      setBrowserType: ActionCreators.setBrowserType
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContentWrapper)
);
